<div class="content" [class.with-url]="allowUrl">
  @if (listLabel) {
    <label>{{ listLabel }}</label>
  }
  @for (item of items; track $index; let i = $index) {
    <div class="input-row" data-cy="named-file-row">
      <div class="input-container">
        <label class="index">{{ i + 1 }}</label>
        <app-textfield
          class="name-field"
          [value]="nameOf(item)"
          placeholder="{{ entityName }} Name"
          (valueChange)="onNameChange($event, i)"
          [error]="nameError(i)"
          [disabled]="disabled"
          [readonly]="disabled"
        ></app-textfield>
        @if (allowUrl) {
          <app-textfield
            class="url-field"
            size="full"
            placeholder="https://..."
            [value]="item.url"
            (valueChange)="onUrlChange($event, i)"
            [error]="rowError(i, 'url')"
            [disabled]="disabled"
            [readonly]="disabled"
          ></app-textfield>
        } @else if (!item.url) {
          <div class="field">
            <span [class.filled]="item.file?.name">{{ item.file?.name || uploadPlaceholder }}</span>
          </div>
        }
        @if (!disabled) {
          @if (item.url) {
            <app-button
              type="primary"
              iconUrl="../../../../assets/images/icons/update.svg"
              [disableBtn]="uploadingCount > 0"
              (click)="fileInput.click()"
              data-cy="update-file-btn"
            >
              Update
            </app-button>
          } @else {
            <label class="upload-btn" [class.disabled]="uploadingCount > 0" [for]="'input-' + id + i" data-cy="browse-file-btn">Browse</label>
          }
        }
        @if (allowCopy && item.url) {
          <app-button type="basic" (click)="copyUrl(i)" data-cy="copy-url-btn">{{ copiedIndex === i ? 'Copied!' : 'Copy URL' }}</app-button>
        }
        @if (!disabled) {
          <app-button
            type="danger"
            iconUrl="../../../../assets/images/icons/delete.svg"
            [disableBtn]="uploadingCount > 0"
            (click)="removeItem(i)"
            data-cy="remove-file-btn"
          >
            Remove
          </app-button>
        }
        <input #fileInput type="file" [id]="'input-' + id + i" [accept]="accept" (change)="onFileChange(fileInput, i)" data-cy="named-file-input" />
      </div>
      @if (item.url && !allowUrl) {
        <div class="selected-file-container">
          <img src="../../../../assets/images/icons/link.svg" alt="link" />
          <div class="selected-value">{{ item.url }}</div>
        </div>
      }
    </div>
  }
  @if (listError) {
    <p class="list-message error">{{ listError }}</p>
  }
  @if (uploadingCount > 0) {
    <p class="list-message">Uploading...</p>
  }
  @if (uploadError) {
    <p class="list-message error">{{ uploadError }}</p>
  }
  @if (!disabled) {
    <app-button type="primary" iconUrl="../../../../assets/images/icons/plus.svg" (click)="addNew()" data-cy="add-file-btn">
      {{ entityName }}
    </app-button>
  }
</div>
